import { render, staticRenderFns } from "./ExerciseSelect.vue?vue&type=template&id=58e78452&scoped=true&"
import script from "./ExerciseSelect.vue?vue&type=script&lang=js&"
export * from "./ExerciseSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e78452",
  null
  
)

export default component.exports